jQuery(document).ready(function ($) {
  //console.log($("button.product-submit").length);

  if ($("button.product-submit").length == 1) {
    $("button.product-submit").hide();
    // $( '<button type="button" class="td-submit" variant_id=""><span class="td-text">Book Now</span></button>' ).insertAfter( ".product-form-grid-select" );

    var select_var = $("select.td-select").find(":selected").attr("value");
    var tdOldQty = $("#" + select_var).attr("data-qty");
    var currentQty = $(".td-quantity").val();
    //alert(parseInt(currentQty)+">"+ parseInt(tdOldQty));
    if (parseInt(currentQty) > parseInt(tdOldQty)) {
      //alert('test');
      $(".td-quantity").val(tdOldQty);
    }
    $(".td-quantity").attr("max", tdOldQty);
    $("button.td-submit").attr("variant_id", select_var);

    $("select.single-option-selector").on("change", function () {
      //alert('test');
      //var current_attr = $(this).attr("dataname");
      var current_attr = $(this).find(":selected").attr("dataname");

      //alert(current_attr);
      $("select.td-select > option").each(function () {
        //console.log($(this).attr('tdname'));
        if ($(this).attr("tdname") == current_attr) {
          var select_var = $(this).attr("value");
          //alert(select_var);
          var vId = "#" + select_var;
          //alert(vId);
          var currentQtyUpdate = $(".td-quantity").val();
          var tdQty = $(vId).attr("data-qty");
          if (parseInt(currentQtyUpdate) > parseInt(tdQty)) {
            //alert('test');
            $(".td-quantity").val(tdQty);
          }
          $(".td-quantity").attr("max", tdQty);
          if (select_var != undefined) {
            $("button.td-submit").attr("variant_id", select_var);
          }
        }
      });
    });

    // On click event
    $(document).on("click", ".td-submit", function () {
      var variant_id = $(this).attr("variant_id");
      var qty = $("input.product-quantity-input").val();
      //console.log(variant_id+"=="+qty);

      $.post("/cart/add.js", { quantity: qty, id: variant_id });
      setTimeout(function () {
        window.location.href = "https://" + window.location.hostname + "/cart";
      }, 1000);
    });
  }
});
